import { icon } from 'leaflet';

/*
 * Hydranten-Marker-Icons (zentral, damit die Logik nicht mehrfach im Code steht).
 *
 * Die Grafiken werden immer unter  img/300/Hydrantenpflege/mapMarkers/  referenziert.
 * Installationsspezifische Overrides werden NICHT hier behandelt, sondern
 * automatisch vom Webserver: die .htaccess im Web-Root liefert img/<x> aus
 * store/AppData/<x> aus, falls dort eine eigene Datei liegt. So gilt dieselbe
 * Override-Logik für alle Assets (Marker, Logo, Login-Hintergrund, ...).
 */
const BASE = 'img/300/Hydrantenpflege/mapMarkers/';

// Baut den Dateinamen aus Status + Mängel-Liste.
export function hydrantMarkerFilename(status, mangel) {
  const list = Array.isArray(mangel) ? mangel : [];
  const anzahl = list.filter((o) => o !== '').length;
  const nichtNutzbar = ['03', '06', '09', '10', '12'].some((c) => list.includes(c));
  const evtlNichtNutzbar = list.includes('13');
  const suffix = `${anzahl > 0 ? '-alert' : ''}${nichtNutzbar ? '-cross' : (evtlNichtNutzbar ? '-question' : '')}`;
  return `hydrant_status_${status}${suffix}.png`;
}

// Liefert das Leaflet-Icon für einen Hydranten.
export function hydrantIcon(status, mangel) {
  return icon({
    iconUrl: BASE + hydrantMarkerFilename(status, mangel),
    iconSize: [20, 20],
    iconAnchor: [10, 20],
  });
}
